export const researchModeSelector = ({researchMode}) => researchMode